import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IMeetingTypes } from "../meetingtypesModel";

export const getAllMeetingTypes = createAsyncThunk(
  "MeetingTypes/FindAllMeetingTypes",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/MeetingTypes/FindAllMeetingTypes`,
        {
          meeting_type: "",
        }
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Service:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveMeetingTypes = createAsyncThunk(
  "MeetingTypes/FindAllActiveMeetingTypes",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/MeetingTypes/FindAllActiveMeetingTypes`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching MeetingTypes:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createMeetingTypes = createAsyncThunk(
  "MeetingTypes/InsertMeetingTypes",
  async (MeetingTypesData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/MeetingTypes/InsertMeetingTypes`,
        MeetingTypesData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating MeetingTypes:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateMeetingTypes = createAsyncThunk(
  "MeetingTypes/UpdateMeetingTypes",
  async (MeetingTypesData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/MeetingTypes/UpdateMeetingTypes`,
        MeetingTypesData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating MeetingTypes:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getMeetingTypesByID = createAsyncThunk(
  "MeetingTypes/FindByIDMeetingTypes",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/MeetingTypes/FindByIDMeetingTypes`,
        { meeting_type_guid: ID }
      );
      const result = response.data?.Data as any;
      return {
        meeting_type: result.meeting_type,
        meeting_type_guid: result.meeting_type_guid,
        isactive: result.isactive === true ? 1 : 2,
      } as IMeetingTypes;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching MeetingTypes:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const MeetingTypesActiveInactive = createAsyncThunk(
  "MeetingTypes/ActiveInActiveMeetingTypes",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/MeetingTypes/ActiveInActiveMeetingTypes`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive MeetingTypes:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteMeetingTypes = createAsyncThunk(
  "MeetingTypes/DeleteMeetingTypes",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/MeetingTypes/DeleteMeetingTypes`,
        { meeting_type_guid: ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting typeofservice:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
